import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { ReactNode } from "react";

interface PageHeaderProps {
  title: string;
  description?: string;
  backTo?: string;
  backLabel?: string;
  actions?: ReactNode;
}

/**
 * Shared page header used by authenticated pages so titles, subtitles and
 * back-links stay visually consistent and always render a semantic <h1>.
 */
export function PageHeader({
  title,
  description,
  backTo,
  backLabel = "Back to Dashboard",
  actions,
}: PageHeaderProps) {
  return (
    <header className="glass-nav">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between gap-4">
        <div className="min-w-0">
          {backTo && (
            <Link
              to={backTo}
              className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-crystal-white"
            >
              <ArrowLeft className="h-3 w-3" />
              {backLabel}
            </Link>
          )}
          <h1 className="text-2xl font-bold text-crystal-white truncate">{title}</h1>
          {description && (
            <p className="text-sm text-muted-foreground">{description}</p>
          )}
        </div>
        {actions && <div className="flex gap-2 shrink-0">{actions}</div>}
      </div>
    </header>
  );
}

export default PageHeader;